<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    style="
      margin: auto;
      background: none;
      display: block;
      shape-rendering: auto;
    "
    width="31px"
    height="31px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle cx="31" cy="50" fill="#164194" r="19">
      <animate
        attributeName="cx"
        repeatCount="indefinite"
        dur="0.6578947368421053s"
        keyTimes="0;0.5;1"
        values="31;69;31"
        begin="-0.32894736842105265s"
      ></animate>
    </circle>
    <circle cx="69" cy="50" fill="#15a3e8" r="19">
      <animate
        attributeName="cx"
        repeatCount="indefinite"
        dur="0.6578947368421053s"
        keyTimes="0;0.5;1"
        values="31;69;31"
        begin="0s"
      ></animate>
    </circle>
    <circle cx="31" cy="50" fill="#164194" r="19">
      <animate
        attributeName="cx"
        repeatCount="indefinite"
        dur="0.6578947368421053s"
        keyTimes="0;0.5;1"
        values="31;69;31"
        begin="-0.32894736842105265s"
      ></animate>
      <animate
        attributeName="fill-opacity"
        values="0;0;1;1"
        calcMode="discrete"
        keyTimes="0;0.499;0.5;1"
        dur="0.6578947368421053s"
        repeatCount="indefinite"
      ></animate>
    </circle>
  </svg>
</template>